import { render, staticRenderFns } from "./StockOrderItemTable.vue?vue&type=template&id=0b01fd82&scoped=true"
import script from "./StockOrderItemTable.vue?vue&type=script&lang=ts"
export * from "./StockOrderItemTable.vue?vue&type=script&lang=ts"
import style0 from "./StockOrderItemTable.vue?vue&type=style&index=0&id=0b01fd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01fd82",
  null
  
)

export default component.exports